import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { IconArrowLeft as ArrowLeft, IconArrowRight as ArrowRight } from '../../core';
import { textStyle } from '../../styles/mixins/_commonPageContentStyles';

type PaginationProps = {
  previousLink?: string;
  nextLink?: string;
  previous?: string;
  className?: string;
  next?: string;
  previousDisabled?: string;
  nextDisabled?: string;
};

const Pagination = ({
  className = '',
  previous = '',
  previousLink,
  next = '',
  nextLink,
  previousDisabled = '',
  nextDisabled = '',
}: PaginationProps) => (
  <div className={className}>
    <div className="pagination">
      <div>
        {previous && (
          <Link to={previousLink ?? ''} className={`pagination-previous ${previousDisabled}`}>
            <ArrowLeft />
            <span>{previous}</span>
          </Link>
        )}
      </div>
      <div>
        {next && (
          <Link to={nextLink ?? ''} className={`pagination-next ${nextDisabled}`}>
            <span>{next}</span>
            <ArrowRight />
          </Link>
        )}
      </div>
    </div>
  </div>
);

const PaginationStyled = styled(Pagination)`
  padding: 1.5rem 0;
  margin-top: 2.5rem;
  border-top: 0.0625rem solid ${({ theme }) => theme.neutralBorder};

  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      ${textStyle('actions14Sb')}
      background: none;
      border: none;
      display: flex;
      align-items: center;
      gap: 1rem;
      cursor: pointer;
      text-decoration: none;
      padding: 0;

      &.disabled {
        span {
          color: ${({ theme }) => theme.neutralTextDisabled};
        }

        svg {
          color: ${({ theme }) => theme.neutralTextDisabled};
        }
      }
    }

    &-previous,
    &-next {
      transition: color 0.3s ease-in-out;

      &:hover {
        color: ${({ theme }) => theme.primaryTextHover};
      }
    }

    &-previous,
    &-next {
      color: ${({ theme }) => theme.primaryText};
    }
  }
`;

export default PaginationStyled;
